import React from 'react';
import PropTypes from 'prop-types';
import TmntText from '../../components/tmnt-text/tmnt-text';

export default function OrderSummary({ confirmationDetails, returnedOrder, labelOrderId }) {
  const { returnLabelTmnt, dropOffDateTmnt, dropOffDate } = confirmationDetails || {};
  return (
    <ul className="exchange-confirmation-summary" data-testid="exchange-confirmation-summary">
      {returnLabelTmnt && (
        <li data-testid="exchange-confirmation-email">
          <TmntText k={returnLabelTmnt} />
          <span>{returnedOrder.orderDetails?.email}</span>
        </li>
      )}
      {dropOffDateTmnt && (
        <li data-testid="exchange-confirmation-drop-off-date">
          <TmntText k={dropOffDateTmnt} />
          <span>{dropOffDate}</span>
        </li>
      )}
      <li data-testid="exchange-confirmation-order-number">
        <TmntText className="exchange-confirmation-order-number" k="DRE_ORDER_NUMBER" />
        <span>{labelOrderId}</span>
      </li>
      {!dropOffDateTmnt && (
        <li data-testid="exchange-confirmation-drop-off-by">
          <TmntText k="DRE_DROP_OFF_BY" />
        </li>
      )}
    </ul>
  );
} 

OrderSummary.propTypes = {
  confirmationDetails: PropTypes.shape({
    returnLabelTmnt: PropTypes.string,
    dropOffTmnt: PropTypes.string,
    dropOffDate: PropTypes.string,
  }),
  returnedOrder: PropTypes.shape({
    orderDetails: PropTypes.shape({
      email: PropTypes.string,
    }),
  }),
  labelOrderId: PropTypes.string,
};
